module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10266.43e0c084.jpg";